import { Middleware } from 'redux';
import { createLogger } from 'redux-logger';
import baseApi from '../services/apis/setup/baseApi';

const configureMiddleware = (): Middleware[] => {
  const middlewares: Middleware[] = [];

  if ((import.meta as any).env.DEV) {
    const logger = createLogger();
    middlewares.push(logger);
  }
  middlewares.push(baseApi.middleware);
  return middlewares;
};

export default configureMiddleware;